import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { withSchemaCatalog, withSchemaCatalogById } from '../../state/Config';
import { useSchemasAPI } from '../API/Config/useSchemasAPI';
import { SchemaCatalogResponse } from '../../API';

export function useSchemaCatalog(): SchemaCatalogResponse[] | undefined {
  const [schemas, setSchemas] = useRecoilState(withSchemaCatalog);
  const schemasAPI = useSchemasAPI();

  useEffect(() => {
    if (schemas !== undefined) return;
    schemasAPI
      .getAll()
      .then(({ data }) => setSchemas(data.body))
      .catch(() => setSchemas([]));
  }, []);

  return schemas;
}

export function useSchemaName(schemaId: string): string | undefined {
  const getById = useRecoilValue(withSchemaCatalogById);
  return getById(schemaId)?.name;
}
